export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./~/rmc-feedback/es/index.js
// module id = 1718
// module chunks = 3